import { warn as _warn } from "@instructure/console";

/*
 * The MIT License (MIT)
 *
 * Copyright (c) 2015 - present Instructure, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
import { canUseDOM } from '@instructure/ui-dom-utils';
var hasRan = false;
/**
 * ---
 * category: utilities/themes
 * ---
 * Sets the document text direction as it's required for themeable component
 * bidirectional styles.
 */

function setTextDirection() {
  if (hasRan) return;
  hasRan = true;

  if (canUseDOM) {
    var dir = document.documentElement.getAttribute('dir');

    if (!dir) {
      /*#__PURE__*/

      /*#__PURE__*/
      _warn(dir, "[themeable] component styles require setting a 'dir' attribute on the HTML element.\n        To prevent breaking changes, we'll set it to a default value: 'ltr'.");

      document.documentElement.setAttribute('dir', 'ltr');
    }
  }
}

export default setTextDirection;
export { setTextDirection };